import { loadable } from '../../../common/utils/lazyLoading';
const PersonDatabase = loadable(() => import('../PersonDatabase'));
export default [
    {
        id: 'person_database',
        title: 'Person Database',
        route: 'person-database',
        permission: 'administration.people_records.person_database',
        component: PersonDatabase,
        icon: 'user',
    },
];
